export default __webpack_public_path__ + "static/media/partner4.41ce3080.jpeg";